import axios from 'axios';
import Qs from 'qs';

const BASE_URL =
  process.env['NX_PUBLIC_API_BASE_URL'] || 'http://localhost:8080';
console.log('🔧 OData API BASE_URL:', BASE_URL);
console.log(
  '🔧 OData Environment NX_PUBLIC_API_BASE_URL:',
  process.env['NX_PUBLIC_API_BASE_URL'],
);

export class ODataQuery {
  constructor(pathTemplate, pathParams, options) {
    this.pathTemplate = pathTemplate;
    this.pathParams = pathParams || {};
    // this.filters = {};

    // this._include = [];

    if (!options) options = {};

    if (options.timeout !== undefined) {
      this.timeout = options.timeout;
    }

    if (options.httpMethod !== undefined) {
      this.httpMethod = options.httpMethod;
    }
  }

  baseUrl = BASE_URL;
  httpClient = axios;
  httpMethod = 'get';
  pathTemplate = null;
  pathParams = null;
  data = null;
  id = null;
  filters = null;
  sort = null;
  limit = null;
  timeout = 60000;

  getData() {
    return {
      data: this.data,
    };
  }

  setMethod(httpMethod) {
    this.httpMethod = httpMethod;
    return this;
  }

  getURL() {
    let path_str = this.pathTemplate;
    for (const prop in this.pathParams) {
      path_str = path_str.replace(`{${prop}}`, this.pathParams[prop]);
    }

    if (this.id) {
      path_str = path_str + `/${this.id}`;
    }

    return this.baseUrl + path_str;
  }

  async run() {
    const response = await this.httpClient.request({
      url: this.getURL(),
      method: this.httpMethod,
      // params: this.getQueryParams(),
      // data: this.getData(),
      timeout: this.timeout,
      withCredentials: true,
      // paramsSerializer: (params) =>
      // Qs.stringify(params, { arrayFormat: 'repeat' }),
    });

    if (response.status > 299) {
      throw Error('Non-200 response');
    }

    // TODO: handle errors

    if (response.status === 204) {
      return null;
    }

    const data = response.data.value;
    this.data = data;

    // parse data and convert any json strings to json

    // Return the full response data object (includes @odata.count, @odata.context, etc.)
    // but also include the value array for backwards compatibility
    return {
      ...response.data,
      value: data,
    };
  }
}
